(() => {
  if (customElements.get('canvoil-country-selector')) return;
  customElements.define('canvoil-country-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      const button = this.querySelector('button'), list = this.querySelector('ul'), form = this.querySelector('form');
      if (!button || !list || !form) return;
      this.bound = true;
      const close = () => { list.hidden = true; button.setAttribute('aria-expanded', 'false'); };
      button.addEventListener('click', () => {
        const open = list.hidden;
        list.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !list.hidden) { event.preventDefault(); event.stopPropagation(); close(); button.focus(); }
      });
      this.addEventListener('focusout', event => { if (event.relatedTarget && !this.contains(event.relatedTarget)) close(); });
      list.addEventListener('click', event => {
        const link = event.target.closest('a[data-value]');
        if (!link) return;
        event.preventDefault();
        form.querySelector('[name="country_code"]').value = link.dataset.value;
        form.requestSubmit();
      });
      this.outsideClick = event => { if (!this.contains(event.target)) close(); };
      document.addEventListener('click', this.outsideClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.outsideClick);
    }
  });
})();
